module.exports = "https://web-assets.ifttt.com/packs/media/docs/timeline-with-connections-f0f796a8.png";